/** Converts degrees to radians. */
export function degToRad(degrees: number): number {
  return degrees * (Math.PI / 180);
}
